import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import {
  ClassifyPageTracker,
  SuccessPageTracker,
  EditPageTracker,
  EditPayAndPostPageTracker,
  ErrorTracker,
  RefreshPageTracker,
  OtherPagesTracker,
} from './pages';

export const PageViewTracker = () => (
  <ErrorBoundary fallback={<ErrorTracker />}>
    <ClassifyPageTracker />
    <SuccessPageTracker />
    <EditPageTracker />
    <EditPayAndPostPageTracker />
    <RefreshPageTracker />
    <OtherPagesTracker />
  </ErrorBoundary>
);
